import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Label } from 'reactstrap';
import { Checkbox } from 'antd';
// Local deps
import './RFFCheckbox.scss';

const CheckboxGroup = Checkbox.Group;

class RFFCheckbox extends React.Component {
  static initialState = {
    value: '',
  };
  state = RFFCheckbox.initialState;

  _OnChange = e => {
    this.props.input.onChange(e);
  };
  render() {
    const {
      input,
      meta,
      labelCol,
      inputCol,
      errorCol,
      label,
      isRequired,
      options,
      ...otherProps,
    } = this.props;
    return (
      <div className="nf-rff-input-field">
        <Row className="nf-rff-input-field__row">
          {/* <!-- LABEL --> */}
          {label && (
            <Col {...labelCol}>
              <Label className="nf-rff-input-field__label" htmlFor={input.name}>
                {label}
                {isRequired && (
                  <span className="nf-rff-input-field__required">*</span>
                )}
              </Label>
            </Col>
          )}

          {/* <!-- INPUT --> */}
          <Col {...inputCol}>
            <CheckboxGroup onChange={this._OnChange}
              {...input}
              {...otherProps}
            >
              {options.map((option) => (
                <Row>
                  <Checkbox key={option.value} value={option.value}>
                    {option.text}
                  </Checkbox>
                </Row>
              ))}
            </CheckboxGroup>
          </Col>

          {/* <!-- ERROR -> */}
          {meta.touched &&
            meta.error && (
              <Col {...errorCol}>
                <div className="nf-rff-input-field__error">{meta.error}</div>
              </Col>
            )}
        </Row>
      </div>
    );
  }
}

RFFCheckbox.defaultProps = {
  label: '',
  labelCol: { md: 3 },
  inputCol: { md: 6, className: 'text-left' },
  errorCol: { md: 3 },
  isRequired: false,
};

RFFCheckbox.propTypes = {
  input: PropTypes.object.isRequired, // Supplied by React Final Form
  meta: PropTypes.object.isRequired, // Supplied by React Final Form,
  labelCol: PropTypes.object,
  inputCol: PropTypes.object,
  errorCol: PropTypes.object,
  label: PropTypes.string,
  isRequired: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default RFFCheckbox;



// WEBPACK FOOTER //
// ./src/components/form/RFFCheckbox/RFFCheckbox.jsx